import type { PaymentActorId, PaymentKind } from '@/types';
import {
  paymentActorLabel,
  type PaymentActorVocab,
} from '@/lib/paymentActorLabel';

export function PaymentActorSpan({
  actor,
  kind,
  vocab,
  t,
}: {
  actor: PaymentActorId;
  kind: PaymentKind;
  vocab: PaymentActorVocab;
  t: (key: string) => string;
}) {
  const { label, tag } = paymentActorLabel(actor, kind, vocab, t);
  if (!tag) return <>{label}</>;
  return (
    <>
      {label}{' '}
      <span className="font-mono text-[10px] text-violet">({tag})</span>
    </>
  );
}
